import { render, staticRenderFns } from "./quartzManage.vue?vue&type=template&id=026f7492"
import script from "./quartzManage.vue?vue&type=script&lang=js"
export * from "./quartzManage.vue?vue&type=script&lang=js"
import style0 from "./quartzManage.vue?vue&type=style&index=0&id=026f7492&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports